import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import { withDigitalData } from '../../utils/DigitalDataContext';
import ServicesPrices from '../Prices/ServicesPrices';
import SingleChipletSelect from '../ui/SingleChipletSelect/SingleChipletSelect';
import { getWarrantyLabel } from '../ui/WarrantySelect/WarrantySelect.helpers';
import { useWarranty } from './hooks/useWarranty';
import { WarrantyStyles } from './Warranty.style';
import WarrantyModal from './WarrantyModal';

const Warranty = ({
  warrantyOptions,
  setWarrantyOption,
  startsFromLabel,
  tooltipToggle,
  additionalWarrantyLabel,
  sellerName,
  digitalData,
  cart,
  appCtx,
}) => {
  const hookData = useWarranty({
    warrantyOptions,
    setWarrantyOption,
    cart,
    appCtx,
    digitalData,
  });

  if (!hookData.shouldRender) {
    return null;
  }

  const {
    labels,
    isImprovedWarrantyUiEnabled,
    tooltipContent,
    selectHandler,
    handleWarrantyChange,
    toggleModalVisibility,
    modalProps,
    offeringId,
    selected,
    textPrice,
    prices,
    discountBadge,
    name,
  } = hookData;

  const { EXTENDED_WARRANTY_LABEL, MORE_WARRANTY_OPTIONS, WARRANTY_LABEL_TEMPLATE } = labels;

  return isImprovedWarrantyUiEnabled ? (
    <>
      <div className="warranty-container">
        <div className="title">
          <span className="warranty-icon" />
          <p>{EXTENDED_WARRANTY_LABEL}</p>
        </div>
        <div className="highlighted-warranty">
          <div className="label">
            <button
              type="button"
              className={`checkbox ${selected ? 'full' : 'empty'}`}
              onClick={() => selectHandler({ offeringId, selected, textPrice, prices, discountBadge, name })}
            />
            <div className="warranty-name">
              {offeringId
                ? getWarrantyLabel({
                    name,
                    sellerName,
                    warrantyLabelTemplate: WARRANTY_LABEL_TEMPLATE,
                  })
                : name}
            </div>
          </div>
          {prices ? (
            <ServicesPrices priceList={prices} priceCount={prices.length} discountBadge={discountBadge} />
          ) : (
            <span className="price">{textPrice}</span>
          )}
        </div>

        <button type="button" className="more-warranty-options" onClick={toggleModalVisibility}>
          {MORE_WARRANTY_OPTIONS}
        </button>
      </div>
      <WarrantyModal {...modalProps} />
      <style jsx>{WarrantyStyles}</style>
    </>
  ) : (
    <div className="fa--warranty">
      <SingleChipletSelect
        options={warrantyOptions.fieldOptions}
        cheapestOption={warrantyOptions.fieldOptions[0].price}
        tooltipContent={tooltipContent}
        tooltipToggle={tooltipToggle}
        startsFromLabel={startsFromLabel}
        label={EXTENDED_WARRANTY_LABEL}
        onOptionSelected={handleWarrantyChange}
        secondaryLabelIcon="csicon-alert"
        icon="csicon-shield"
        shouldHaveBackground={false}
        type="medium"
        withPadding={false}
        highLightHeading
        clickableChiplet
        additionalWarrantyLabel={additionalWarrantyLabel}
        serviceType="warranty-option"
        hideSubtitle
      />
    </div>
  );
};

Warranty.defaultProps = {
  setWarrantyOption: () => {},
  warrantyOptions: {
    label: '',
    fieldOptions: [],
  },
  startsFromLabel: 'A partir de: ',
  tooltipToggle: false,
  additionalWarrantyLabel: {},
  sellerName: '',
};

Warranty.propTypes = {
  warrantyOptions: PropTypes.object,
  setWarrantyOption: PropTypes.func,
  startsFromLabel: PropTypes.string,
  tooltipToggle: PropTypes.bool,
  additionalWarrantyLabel: PropTypes.object,
  digitalData: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  sellerName: PropTypes.string,
};

export default withCart(withApplicationContext(withDigitalData(Warranty)));
export { Warranty };
